import React, { useState } from 'react';
import { MapPin, Clock, Briefcase, Send, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Karriere() {
  const navigate = useNavigate();
  const [selectedJob, setSelectedJob] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [cvFile, setCvFile] = useState(null);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    street: '',
    zip_code: '',
    city: '',
    nationality: '',
    birth_date: '',
    employment_type: 'Minijob',
    password: '', // Neues Feld für das geschlossene Ökosystem
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e, position) => {
    e.preventDefault();
    setIsLoading(true);

    // Wir senden die Daten als JSON, inklusive Passwort und dem Namen der Datei
    const payload = {
      ...formData,
      position: position,
      cv_filename: cvFile ? cvFile.name : 'Kein Lebenslauf hochgeladen'
    };

    try {
      const response = await fetch('/api/applications/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        navigate('/success');
      } else {
        alert('Es gab ein Problem bei der Übermittlung. Bitte prüfen Sie Ihre Eingaben.');
      }
    } catch (error) {
      console.error('Fehler:', error);
      alert('Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung.');
    } finally {
      setIsLoading(false);
    }
  };

  const renderApplicationForm = (jobTitle) => {
    if (selectedJob !== jobTitle) return null;

    return (
      <form onSubmit={(e) => handleSubmit(e, jobTitle)} className="mt-6 pt-6 border-t border-slate-200 animate-in fade-in slide-in-from-top-4">
        <h4 className="font-bold text-slate-900 mb-4 text-lg">Bewerbung als {jobTitle}</h4>
        
        {/* Name */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-semibold text-slate-800 mb-1">Vorname *</label>
            <input required type="text" name="first_name" value={formData.first_name} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-800 mb-1">Nachname *</label>
            <input required type="text" name="last_name" value={formData.last_name} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
          </div>
        </div>

        {/* Geburtsdatum & Staatsangehörigkeit */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-semibold text-slate-800 mb-1">Geburtsdatum *</label>
            <input required type="date" name="birth_date" value={formData.birth_date} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-800 mb-1">Staatsangehörigkeit *</label>
            <input required type="text" name="nationality" value={formData.nationality} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" placeholder="z.B. Deutsch" />
          </div>
        </div>

        {/* Kontakt */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-semibold text-slate-800 mb-1">E-Mail Adresse *</label>
            <input required type="email" name="email" value={formData.email} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-800 mb-1">Telefonnummer *</label>
            <input required type="tel" name="phone" value={formData.phone} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
          </div>
        </div>

        {/* Adresse */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-slate-800 mb-1">Straße & Hausnummer *</label>
          <input required type="text" name="street" value={formData.street} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
        </div>
        <div className="grid grid-cols-3 gap-4 mb-4">
          <div className="col-span-1">
            <label className="block text-sm font-semibold text-slate-800 mb-1">PLZ *</label>
            <input required type="text" name="zip_code" value={formData.zip_code} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-semibold text-slate-800 mb-1">Stadt *</label>
            <input required type="text" name="city" value={formData.city} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" />
          </div>
        </div>

        {/* Dropdown Anstellungsart */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-slate-800 mb-1">Gewünschte Anstellungsart *</label>
          <select name="employment_type" value={formData.employment_type} onChange={handleInputChange} className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900">
            <option value="Minijob">Minijob (603€-Basis)</option>
            <option value="Teilzeit">Teilzeit</option>
            <option value="Werkstudent">Werkstudent</option>
          </select>
        </div>

        {/* Account Passwort (Neu) */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-slate-800 mb-1">Passwort für Ihren Tester-Account *</label>
          <input 
            required 
            type="password" 
            name="password" 
            value={formData.password} 
            onChange={handleInputChange} 
            placeholder="Mindestens 8 Zeichen" 
            minLength="8"
            className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-900" 
          />
        </div>

        {/* Datei Upload (Visuell) */}
        <div className="mb-8">
          <label className="block text-sm font-semibold text-slate-800 mb-1">Lebenslauf (PDF, DOCX) *</label>
          <input 
            required 
            type="file" 
            accept=".pdf,.doc,.docx"
            onChange={(e) => setCvFile(e.target.files[0])}
            className="w-full p-2.5 border border-slate-300 rounded focus:ring-accent outline-none bg-white text-slate-600 
            file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-bold file:bg-slate-100 file:text-slate-700 hover:file:bg-slate-200 cursor-pointer" 
          />
        </div>

        {/* Buttons */}
        <div className="flex gap-3">
          <button type="submit" disabled={isLoading} className="flex-1 bg-accent text-slate-900 py-3 rounded-md font-bold hover:bg-accent/90 transition-colors flex items-center justify-center gap-2 disabled:opacity-70">
            {isLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
            {isLoading ? 'Wird gesendet...' : 'Bewerbung absenden'}
          </button>
          <button type="button" onClick={() => setSelectedJob(null)} className="px-4 py-3 border border-slate-300 text-slate-700 rounded-md hover:bg-slate-50 transition-colors bg-white font-medium">
            Abbrechen
          </button>
        </div>
      </form>
    );
  };

  return (
    <div className="min-h-screen py-20 px-4 bg-background">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold text-slate-900 mb-4 text-center">Karriere bei RM Digital</h1>
        <p className="text-center text-slate-600 mb-12 max-w-2xl mx-auto font-medium">
          Werden Sie Teil unseres Netzwerks und helfen Sie uns, digitale Produkte fehlerfrei und nutzerfreundlich zu machen.
        </p>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Job 1: Web Application Tester */}
          <div className={`bg-white p-8 rounded-xl border ${selectedJob === 'Web Application Tester' ? 'border-accent ring-1 ring-accent' : 'border-slate-200'} shadow-sm transition-all flex flex-col`}>
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Web Application Tester</h2>
            <div className="flex flex-wrap gap-3 mb-4">
              <span className="inline-flex items-center text-sm bg-slate-100 text-slate-700 px-3 py-1 rounded-full font-medium"><MapPin className="w-4 h-4 mr-1"/> Remote / Homeoffice</span>
              <span className="inline-flex items-center text-sm bg-slate-100 text-slate-700 px-3 py-1 rounded-full font-medium"><Clock className="w-4 h-4 mr-1"/> Flexibel / Minijob</span>
            </div>
            <p className="text-slate-600 mb-4 leading-relaxed">Assistent für Evaluierungen im Homeoffice - Überprüfung von Apps und Software.</p>
            <h3 className="font-bold text-slate-900 mb-2">Anforderungen:</h3>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-1 leading-relaxed">
              <li>Interesse an App- und Software-Testing</li>
              <li>Zuverlässige und selbstständige Arbeitsweise</li>
              <li>Gute Deutschkenntnisse</li>
              <li>PC/Laptop und stabile Internetverbindung</li>
            </ul>
            
            {selectedJob !== 'Web Application Tester' && (
              <button onClick={() => setSelectedJob('Web Application Tester')} className="mt-auto bg-slate-900 text-white w-full py-3 rounded-md hover:bg-slate-800 transition-colors font-bold">
                Jetzt bewerben
              </button>
            )}
            {renderApplicationForm('Web Application Tester')}
          </div>

          {/* Job 2: Werkstudent Quality Assurance */}
          <div className={`bg-white p-8 rounded-xl border ${selectedJob === 'Werkstudent Quality Assurance' ? 'border-accent ring-1 ring-accent' : 'border-slate-200'} shadow-sm transition-all flex flex-col`}>
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Werkstudent Quality Assurance</h2>
            <div className="flex flex-wrap gap-3 mb-4">
              <span className="inline-flex items-center text-sm bg-slate-100 text-slate-700 px-3 py-1 rounded-full font-medium"><MapPin className="w-4 h-4 mr-1"/> Remote / Homeoffice</span>
              <span className="inline-flex items-center text-sm bg-slate-100 text-slate-700 px-3 py-1 rounded-full font-medium"><Briefcase className="w-4 h-4 mr-1"/> Werkstudent</span>
            </div>
            <p className="text-slate-600 mb-4 leading-relaxed">Testen von Mobil- und Webanwendungen in agilen Teams.</p>
            <h3 className="font-bold text-slate-900 mb-2">Anforderungen:</h3>
            <ul className="list-disc list-inside text-slate-600 mb-6 space-y-1 leading-relaxed">
              <li>Interesse an App- und Software-Testing</li>
              <li>Zuverlässige und selbstständige Arbeitsweise</li>
              <li>Gute Deutschkenntnisse</li>
              <li>PC/Laptop und stabile Internetverbindung</li>
            </ul>
            
            {selectedJob !== 'Werkstudent Quality Assurance' && (
              <button onClick={() => setSelectedJob('Werkstudent Quality Assurance')} className="mt-auto bg-slate-900 text-white w-full py-3 rounded-md hover:bg-slate-800 transition-colors font-bold">
                Jetzt bewerben
              </button>
            )}
            {renderApplicationForm('Werkstudent Quality Assurance')}
          </div>
        </div>
      </div>
    </div>
  );
}